import DoxapearlWebsite from './DoxapearlWebsite';

function App() {
  return <DoxapearlWebsite />;
}

export default App;